window.addEventListener("load",function() {
  $(".content-switcher-section-tab").click(function() {
      if (!$(this).hasClass("active")) {
        let index = $(this).index(".content-switcher-section-tab")
        let prevIndex = $(this).siblings(".active").index(".content-switcher-section-tab")
        $(this).siblings().removeClass("active")
        $(this).addClass("active")
        $(this).parents(".content-switcher-section-tabs").siblings(".content-switcher-section-contents").find(".content-switcher-section-content").eq(prevIndex).fadeOut(()=> {
          $(this).parents(".content-switcher-section-tabs").siblings(".content-switcher-section-contents").find(".content-switcher-section-content").eq(index).fadeIn()
          if (document.documentElement.clientWidth < 750) {
            $(this).parents(".content-switcher-section-tabs_wrapper").find(".js-close-switcher").click()
          }
        })
      }
  })
  $(".js-open-switcher").click(function() {
    $("body").addClass("popshow")
    $("html").addClass("popshow")
    $(this).siblings(".content-switcher-section-tabs").fadeIn(function() {
      $(this).find(".content-switcher-section-tabs_wrapper").css({"transform":"translateX(0)"})
    })
  })
  $(".js-close-switcher").click(function() {
    $(this).parent(".content-switcher-section-tabs_wrapper").css({"transform":"translateX(100%)"})
    setTimeout(()=> {
      $(this).parents(".content-switcher-section-tabs").fadeOut()
       $("body").removeClass("popshow")
    $("html").removeClass("popshow")
    },400)
  })
  $(".js-open-navigator").click(function() {
       $("body").addClass("popshow")
    $("html").addClass("popshow")
    $(this).siblings(".navigator_section").fadeIn(function() {
      $(this).find(".navigator_container").css({"transform":"translateX(0)"})
    })
  }) 
  $(".js-close-navigator").click(function() {
    $(this).parent(".navigator_container").css({"transform":"translateX(100%)"})
    setTimeout(()=> {
      $(this).parents(".navigator_section").fadeOut()
       $("body").removeClass("popshow")
    $("html").removeClass("popshow")
    },400)
  })
  if (document.documentElement.clientWidth < 750) {
    $(".navigator_container").find("a").click(function() {
            $(this).siblings(".js-close-navigator").click()
    })
  }
})